export default __webpack_public_path__ + "static/media/com-foto1.a7fe5d12.jpg";